/**
 * Specifies Type of User for Graphics.
 */
export enum UserType {
  NORMAL = 'NORMAL',
  PROUSER = 'PROUSER',
  DESIGNUSER = 'DESIGNUSER',
}
